<template>
  <div style="height2: 550px" class="overflow-y-auto mt-2 mb-2 w-full bg-white flex flex-row items-start w-full">
    <table class="w-full text-sm text-left text-gray-500 ">
      <tbody>
        <tr v-for="(record, index) in records" :key="record.id" class="cursor-pointer border-b ">
          <td class="px-4 py-4">
            <div class="flex items-center">
              <div class="pl-3">
                <div class="text-base font-semibold">
                  {{ record?.name?.FR }}
                </div>
                <div class="font-normal text-gray-500">
                  {{ buildDescription(record) }}
                </div>
              </div>
            </div>
          </td>

          <td class="text-right w-4 px-4 py-4">
            <label class="inline-flex items-center cursor-pointer">
              <input :id="`switch-list-active-${index}`" type="checkbox" value="" class="sr-only peer" :checked="record.default" @click="onSelectSwitch(record, index)" />
              <div
                class="relative w-11 h-6 bg-gray-200 rounded-full peer peer-focus:ring-4 peer-focus:ring-blue-300   peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-blue-600 "
              ></div>
            </label>
          </td>

          <td class="text-right px-4 py-2 bg-orange-100 min-w-96 items-center w-4/12">
            <div class="flex flex-row w-full" v-if="record.type == 'range' && output[record._id] != undefined && output[record._id].state == true">
              <div class="max-w-sm mx-auto flex items-center">
                <label for="number-input" class="block mb-2 text-sm font-medium text-gray-900  pr-2 pl-4">Min :</label>
                <input
                  :id="`switch-list-min-${index}`"
                  type="number"
                  :value="output[record._id].min"
                  aria-describedby="helper-text-explanation"
                  class="bg-gray-50 border border-gray-300 text-gray-900 w-8 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-16 p-1.5      "
                  placeholder=""
                />
              </div>
              <div class="max-w-sm mx-auto flex items-center">
                <label for="number-input" class="block mb-2 text-sm font-medium text-gray-900  pr-2 pl-4">Max :</label>
                <input
                  :id="`switch-list-max-${index}`"
                  type="number"
                  :value="output[record._id].max"
                  aria-describedby="helper-text-explanation"
                  class="bg-gray-50 border border-gray-300 text-gray-900 w-8 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-16 p-1.5      "
                  placeholder=""
                />
              </div>
              <div class="max-w-sm mx-auto flex items-center">
                <label for="number-input " class="block mb-2 text-sm font-medium text-gray-900  pr-2 pl-4">Unité :</label>
                <select
                  :id="`switch-list-temperature ${index}`"
                  class="bg-gray-50 border border-gray-300 text-gray-900 w-16 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5      "
                >
                  <option :selected="output[record._id].unit == '-'">-</option>
                  <option :selected="output[record._id].unit == '°C'" value="°C">°C</option>
                  <option :selected="output[record._id].unit == 'l'" value="l">l</option>
                  <option :selected="output[record._id].unit == 'lg'" value="kg">kg</option>
                  <option :selected="output[record._id].unit == '%'" value="%">%</option>
                </select>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  {{ this.output }}
</template>
<script>
// import { Modal} from 'flowbite';
import service from "@/services/FullService.vue";
import { mapGetters } from "vuex";
import labels from "@/assets/lg/products.json";

export default {
  name: "ContentSwitchList",
  components: {},
  props: {
    id: String,
    label: String,
    value: Object,
    category: String,
    config: Object,
  },
  emits: ["manageField"],
  data() {
    return {
      records: [],
      output: {},
      checkboxes: {},
      selected: {},

      labels: labels,
      lg: "FR",
    };
  },
  watch: {
    value: function () {
      // this.loadControls();

      for (let i = 0; i < this.records.length; i++) {
        if (this.output[this.records[i]._id] == undefined) {
          this.output[this.records[i]._id] = { state: this.records[i].default, min: this.records[i].min, max: this.records[i].max, unit: this.records[i].unit };
        }
      }

      //   if (this.value == undefined) this.records = [];
      //   else this.records = this.value;
    },
  },
  computed: {
    ...mapGetters({ user: "StateUser" }),
    isLoggedIn: function () {
      return this.$store.getters.isAuthenticated;
    },
    isDeveloper: function () {
      return this.user?.isDeveloper;
    },
  },
  mounted() {
    this.loadControls();

    // if (this.value == undefined) this.records = [];
    //else this.records = this.value;
  },
  methods: {
    onSelectSwitch(record/*, index*/) {
    
      if (this.output[record._id] == null) {
        this.output[record._id].state = false;
      } else {
        this.output[record._id].state = !this.output[record._id].state;
      }
    },
    onClickDocumentButton() {
      this.addProductDocumentModal.show();
    },

    onCloseDocumentButton() {
      this.addProductDocumentModal.hide();
    },

    getData() {
      
      return this.output;
    },
    onClickDelete() {},

    buildDescription(record) {
      if (this.category == "iso") {
        return "Certifié par " + record.company_name;
      }
    },

    async loadControls() {
      let limit = 200;
      let offset = 0;

      let records = await service.getData("data-sources/683ea8387c310b71c69166f6/records", this.user?.token, Object.assign({}, { limit: limit, offset: offset }, {}));

      if (records?.records != undefined) {
        this.records = records?.records;

        for (let i = 0; i < this.records.length; i++) {
          if (this.output[this.records[i]._id] == undefined) {
            this.output[this.records[i]._id] = { state: this.records[i].default, min: this.records[i].min, max: this.records[i].max, unit: this.records[i].unit };
          }
        }
      }
    },

    onValidate(item) {
      this.records.push(
        {
          id: item.document.id,
          name: item.name,
          filename: item.document.name,
          mimeType: "application/pdf",
          format: "pdf",
          size: "",
          image: item.document.url,
        }
        //
      );
    },
    buildAvatar(v1, v2, record) {
      let a1 = this.manageVariable(v1, record);
      let a2 = this.manageVariable(v2, record);

      if (a1 == undefined || a1 == "") a1 = "";
      else a1 = a1[0].toUpperCase();

      if (a2 == undefined || a2 == "") a2 = "";
      else a2 = a2[0].toUpperCase();

      if (a1 == "" && a2 == "") a1 = "-";

      return a1 + a2;
    },
  },
};
</script>
